import { Skeleton } from '@mui/material';
import { FC, memo } from 'react';
import { Page, PageContent, PageTitle } from '../styles';
import { ApptRequestsListSkeleton } from './appt-request-list/appt-request-list.skeleton';

export interface ApptRequestsViewSkeletonProps {
  title?: string;
}

export const ApptRequestsViewSkeleton: FC<ApptRequestsViewSkeletonProps> = memo((props) => {
  const { title } = props;

  return (
    <Page>
      <PageTitle>
        {title ? title : <Skeleton variant="text" height={30} width={180} />}
        <Skeleton variant="circular" height={32} width={32} />
      </PageTitle>
      <PageContent sx={{ margin: '0 0 20px 0' }}>
        <ApptRequestsListSkeleton />
      </PageContent>
    </Page>
  );
});
